import { render } from "./StoryEditorComponent.vue.js?vue&type=template&id=12b5e22c&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryEditorComponent.vue?vue&type=template&id=12b5e22c&scoped=true"
import script from "./StoryEditorComponent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryEditorComponent.vue?vue&type=script&lang=js"
export * from "./StoryEditorComponent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryEditorComponent.vue?vue&type=script&lang=js"

import "./StoryEditorComponent.vue.scss?vue&type=style&index=0&id=12b5e22c&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryEditorComponent.vue?vue&type=style&index=0&id=12b5e22c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b5e22c"],['__file',"src/Web/scripts/components/publication/StoryEditorComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12b5e22c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12b5e22c', __exports__)) {
    api.reload('12b5e22c', __exports__)
  }
  
  module.hot.accept("./StoryEditorComponent.vue.js?vue&type=template&id=12b5e22c&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryEditorComponent.vue?vue&type=template&id=12b5e22c&scoped=true", () => {
    api.rerender('12b5e22c', render)
  })

}


export default __exports__